import NavLinkAdapter from '../NavLinkAdapter';
import FuseUtils from '@/@fuse/utils';
import * as Actions from '@/app/store/actions';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import ListItem from '@material-ui/core/ListItem';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const NavItemBase = ({ item }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const userRole = useSelector(({ auth }) => auth.user.role);
	const userPermission = useSelector(
		({ auth }) =>
			(auth.user.permissions ?? auth.user.data.permissions)?.map((permission) => permission.replace(/^\/+/i, '')) ?? []
	);
	const containsActiveRoute = item.subLinks?.some((child) =>
		child.end ? location.pathname === child.url : location.pathname.startsWith(child.url)
	);
	const [isOpen, setIsOpen] = useState(!!containsActiveRoute);
	const { t } = useTranslation('navigation');

	if (!userPermission.includes(item.permission) && !item.alwaysShow) {
		return null;
	}
	if (!FuseUtils.hasPermission(item.auth, userRole)) {
		return null;
	}

	if (item.subLinks) {
		return (
			<div className="flex flex-col text-white font-inter text-16 group">
				<hr className="mx-20" />
				<ListItem
					button
					className="flex justify-between items-center py-[12px] pl-20 group-has-[.active]:bg-white/5 group-has-[.active]:shadow-md"
					disableRipple
					onClick={() => setIsOpen(!isOpen)}
				>
					<div className="flex items-center gap-16">
						{item.icon}
						<span className="font-inter font-semibold">{item.translate ? t(item.translate) : item.title}</span>
					</div>
					<div className="flex items-center">
						<ChevronDownIcon className={`size-16 ml-8 transition-all duration-250 ${isOpen ? 'scale-y-[-1]' : ''}`} />
					</div>
				</ListItem>

				<div
					className={clsx(
						'overflow-hidden transition-all duration-250 ease-in-out ',
						isOpen ? 'max-h-screen' : 'max-h-0'
					)}
				>
					{item.subLinks.map((child) => (
						<ListItem
							button
							className="pl-[52px] [&.active]:bg-white/10 [&.active]:shadow-md py-[12px]"
							component={NavLinkAdapter}
							disableRipple
							end={child.end}
							key={child.id}
							onClick={() => dispatch(Actions.navbarCloseMobile())}
							to={child.url}
						>
							<span className="font-inter">{child.translate ? t(child.translate) : child.title}</span>
						</ListItem>
					))}
				</div>
				<hr className="mx-20" />
			</div>
		);
	}

	return (
		<ListItem
			button
			className="flex text-white font-inter text-16 [&.active]:bg-white/10 [&.active]:shadow-md py-12 pl-20"
			component={NavLinkAdapter}
			disableRipple
			exact={item.exact}
			onClick={() => dispatch(Actions.navbarCloseMobile())}
			to={item.url}
		>
			<div className="flex items-center gap-16">
				{item.icon}
				<span className="font-inter capitalize leading-[2] font-semibold">
					{item.translate ? t(item.translate) : item.title}
				</span>
			</div>
		</ListItem>
	);
};

NavItemBase.propTypes = {
	item: PropTypes.shape({
		id: PropTypes.string.isRequired,
		title: PropTypes.string,
		url: PropTypes.string,
		children: PropTypes.array,
		icon: PropTypes.node,

	}),
};

const NavItem = React.memo(NavItemBase);

export default NavItem;
